(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('collections', collections);

    /**
    * @ngdoc service
    * @name swif.framework.collections
    * @requires swif.framework.dataService
    * @requires swif.framework.actionService
    * @requires swif.framework.msgService
    * @requires swif.framework.cart
    * @requires swif.framework.attachmentService
    * @requires swif.framework.settingsService
    * @requires swif.framework.downloadSrv
    * @requires swif.framework.gettextCatalog
    * @requires swif.framework.swifMomentUtility
    * @requires swif.framework.FrameworkImportCSVService
    **/
    function collections($rootScope, $q, $location, $localStorage, dataService, actionService, msgService,
                         swifFrameworkCartService, AttachmentService, settingsService, swifMomentUtility,
                         swifDownloadService, gettextCatalog, FrameworkImportCSVService) {
        'ngInject';
        var cart = swifFrameworkCartService;
        var downloadSrv = swifDownloadService;
        var i18n = gettextCatalog;
        var service = {
            collections: {},
            loading: {items: {}, item: {}},
            defaultActionIds: [
                'activate',
                'add',
                'add_to_cart',
                'add_collection_to_cart',
                'cancel',
                'copy',
                'delete',
                'deactivate',
                'edit',
                'print',
                'print_collection',
                'rm_from_cart'
            ],
            onError: onError,
            getCollection: getCollection,
            defaultCallbackMessage: defaultCallbackMessage,
            preValidate: preValidate,
            updateItem: updateItem,
            createCollection: createCollection,
            createOrUpdate: createOrUpdate,
            addCollection: addCollection,
            getItem: getItem,
            getCurrentItemId: getCurrentItemId,
            setCurrentItem: setCurrentItem,
            _updateParams: _updateParams,
            getItems: getItems,
            refreshCollections: refreshCollections,
            addCollectionToScope: addCollectionToScope,
            saveAs: _saveAs
        };
        cart.onDelete.push(function (contentType) {
            _.forEach(service.collections, function (coll) {
                if (coll.contentType === contentType) {
                    _.forEach(coll.items, function (item) {
                        actionService.updateActions(item);
                    });
                }
            });
        });
        return service;

        function onError(error) {
            msgService.addError(error);
            msgService.loading(service.loading.items, 'ko');
            msgService.loading(service.loading.item, 'ko');
        }

        function getCollection(id) {
            return service.collections[id];
        }

        function defaultCallbackMessage(error, data) {
            if (error) {
                return;
            }
            switch (data.action.id) {
            case 'add':
                msgService.addInfo('Item has been added successfully');
                break;
            case 'edit':
                msgService.addInfo('Item has been updated successfully');
                break;
            case 'delete':
                msgService.addInfo('Item has been deleted successfully');
                break;
            case 'deactivate':
                msgService.addInfo('Item has been deactivated successfully');
                break;
            case 'activate':
                msgService.addInfo('Item has activated successfully');
                break;
            case 'add_to_cart':
                msgService.addInfo('Item has been added to cart successfully');
                break;
            case 'add_collection_to_cart':
                msgService.addInfo('All items has been added to cart successfully');
                break;
            case 'rm_from_cart':
                msgService.addInfo('Item has been removed from cart successfully');
                break;
            }
        }

        function preValidate(data) {
            var valid = true;
            if (data.action.id === 'deactivate') {
                data.model.active = false;
            } else if (data.action.id === 'activate') {
                data.model.active = true;
            } else if (data.action.id === 'print') {
                //sanitize the model
                if (_.isArray(data.model._report)) {
                    data.model._report = data.model._report[0];
                }
                return dataService.downloadReport(
                    data.model._type,
                    data.model._report,
                    [data.model.id],
                    data.model,
                    data.model.context
                ).then(function () {
                    if (data.model.printParams) {
                        downloadSrv.params = data.model.printParams;
                    }
                    return true;
                });
            } else if (data.action.id === 'export' || data.action.id === 'export_collection') {
                var fields = [];
                if (data.model.exportCSV.fields.selected.id == 'only') {
                    fields = data.action.exportOnlyFields;
                } else {
                    fields = data.action.exportFields;
                }

                var kwargs = {};
                kwargs['skip_header'] = data.model.exportCSV.skipHeader;

                if (data.model.exportCSV.quantity && data.model.exportCSV.quantity.selected.id === 'manual') {
                    kwargs['repeat_row'] = data.model.exportCSV.quantity.manual;
                } else {
                    kwargs['repeat_field'] = 'qty_available';
                }

                var exportItemIds = [];
                var filename = null;
                var contentType = null;

                if (data.action.id === 'export') {
                    exportItemIds.push(data.model.id)
                    filename = data.model.name;
                    contentType = data.model._type;
                } else {
                    angular.forEach(data.model.items, function(item) {
                        exportItemIds.push(item.id);
                    });
                    if (data.model.items.length == 1) {
                        filename = data.model.items[0].name;
                    }
                    contentType = data.model.contentType;
                }

                return dataService.exportCSV(
                    contentType,
                    fields,
                    exportItemIds,
                    filename,
                    kwargs
                ).then(function () {
                    return true;
                });

            } else if (data.action.id === 'copy') {
                delete data.model.id;
                delete data.model.state;
                delete data.model.actions;
            } else if (data.action.id === 'print_collection') {
                if (data.action.barcode_reports){
                    if (_.isArray(data.model._reportEAN13)) {
                        data.model._reportEAN13 = data.model._reportEAN13[0];
                    }
                    var ids = _.pluck(data.model.listEAN13, 'id');
                    dataService.downloadReport(
                        data.model.contentType,
                        data.model._reportEAN13,
                        ids,
                        data.model,
                        data.model.context
                    ).then(function () {
                        if (data.model.printParams) {
                            downloadSrv.params = data.model.printParams;
                        }
                        return true;
                    });
                    if (_.isArray(data.model._reportCode128)) {
                        data.model._reportCode128 = data.model._reportCode128[0];
                    }
                    var ids = _.pluck(data.model.listCode128, 'id');
                    dataService.downloadReport(
                        data.model.contentType,
                        data.model._reportCode128,
                        ids,
                        data.model,
                        data.model.context
                    ).then(function () {
                        if (data.model.printParams) {
                            downloadSrv.params = data.model.printParams;
                        }
                        return true;
                    });
                } else {
                    if (_.isArray(data.model._report)) {
                        data.model._report = data.model._report[0];
                    }
                    var ids = _.pluck(data.model.items, 'id');
                    dataService.downloadReport(
                        data.model.contentType,
                        data.model._report,
                        ids,
                        data.model,
                        data.model.context
                    ).then(function () {
                        if (data.model.printParams) {
                            downloadSrv.params = data.model.printParams;
                        }
                        return true;
                    });
                }
            } else if (data.action.id === 'import_csv') {
                valid = FrameworkImportCSVService.preValidate(data);
            }
            if (data.action.id === 'add_to_cart') {
                cart.addToCart(data.model);
                data.model.__updateActions = true;
            } else if (data.action.id === 'rm_from_cart') {
                cart.rmFromCart(data.model);
                data.model.__updateActions = 1;
            }
            if (data.action.id === 'add_collection_to_cart') {
                if (data.model.items.length === 0) {
                    valid = false;
                } else {
                    // fetch all records matching the filter,
                    // then, fasterCallback will add them on the cart
                    // @TOCHECK: http search_read request on default.json, useless ?
                    var params = angular.copy(data.model.currentFilter);
                    params.fields = ['id', 'name', 'complete_name'];
                    params.limit = 0;
                    dataService.replaceObj(data.model, params);
                }
            }
            return valid;
        }

        /**
         * Update all item instance accross all collections
         */
        function updateItem(item) {
            _.forOwn(service.collections, function (collection) {
                if (collection.contentType === item._type) {
                    collection.updateItem(item);
                }
            });
        }

        function createCollection(id, contentType, filter, options) {
            var c = service.collections[id];
            if (c !== undefined) {
                return c;
            }
            if (options === undefined) {
                options = {};
            }
            service.collections[id] = angular.copy(options);
            if (filter) {
                service.collections[id].currentFilter = filter;
            }
            _.defaults(service.collections[id], {
                vocabulariesConfiguration: {},
                vocabularies: {},
                currentPage: 1,
                currentFilter: {},
                currentCount: 0,
                currentItem: undefined,
                reverse: true,
                predicate: 'id',
                items: [],
                contentType: contentType,
                location: false,
                loading: {items: {}, item: {}}
            });
            c = service.collections[id];
            if (service.collections[id].limitPerPage>=0){
                c.currentFilter.limit = service.collections[id].limitPerPage;
            }
            if (c.currentFilter.limit===undefined){
                c.currentFilter.limit = 20;
            }
            c._type = 'collection';
            c.id = id;
            c.getItems = getItems;
            c.reload = c.getItems;
            c.refresh = c.getItems;
            c.setCurrentFromLocation = setCurrentFromLocation;
            c.setConfigurationFromLocation = setConfigurationFromLocation;
            c.onError = onError;
            c.getItem = getItem;
            c.getCurrentItemId = getCurrentItemId;
            c.refreshCurrent = refreshCurrent;
            c.setCurrent = setCurrent;
            c.setCurrentItem = setCurrent;
            c.updateLocation = updateLocation;
            c.callbackRefresh = callbackRefresh;
            c.fasterCallback = fasterCallback;
            c.preModal = preModal;
            c.defaultActionCallback = defaultActionCallback;
            c.callback = c.defaultActionCallback;
            c.preValidate = service.preValidate;
            c.updateItem = updateItem;
            c.removeItem = removeItem;
            c.replaceItems = replaceItems;
            c.onFilterUpdate = [];
            c.lastUpdateDateTime = '';

            $rootScope.$watch(function () {
                if (c.currentItem) {
                    return c.currentItem.id;
                }
            }, function (newV, oldV) {
                if (newV === oldV) {
                    return;
                }
                c.updateLocation();
            }, true);
            $rootScope.$watch(function () {
                return [c.currentFilter, c.currentPage];
            }, function (newV, oldV) {
                if (newV) {
                    if (oldV) {
                        if (angular.equals(newV, oldV)) {
                            return;
                        }
                    }
                    service.getItems(c.id).then(function () {
                        c.updateLocation();
                    });
                }
            }, true);

            c.setConfigurationFromLocation();
            return c;

            function _parseLocation() {
                var prefix = 'c:' + id;
                var location = $location.search()[prefix];
                if (location) {
                    return JSON.parse(location);
                }
                return {};
            }
            function getItems() {
                service._updateParams(c);
                msgService.loading(c.loading.items);
                return dataService._get(c.contentType, undefined, c.currentFilter)
                .then(function (data) {
                    c.lastUpdateDateTime = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                    if (data.length >= 0) {
                        c.currentCount = parseInt(data.length, 10);
                    }
                    c.items = data.records;
                    msgService.loading(c.loading.items, 'ok');
                    if (c.location) {
                        c.setCurrentFromLocation();
                    }
                    return c.items;
                }, c.onError);
            }
            function setCurrentFromLocation() {
                var deferred = $q.defer();
                var result = {};
                var parsed = _parseLocation();
                if (parsed.current) {
                    var currentId = parseInt(parsed.current, 10);
                    var updateCurrent = true;
                    if (c.currentItem) {
                        if (c.currentItem.id === currentId) {
                            updateCurrent = false;
                        }
                    }
                    if (updateCurrent) {
                        //TODO; try to find it from the items
                        _.forEach(c.items, function (item) {
                            if (item.id === currentId) {
                                c.setCurrent(item);
                            }
                        });
                        return c.setCurrent(currentId);
                    }
                } else {
                    deferred.resolve(result);
                }
                return deferred.promise;
            }
            function setConfigurationFromLocation() {
                var parsed = _parseLocation();
                if (!_.isEqual(c.currentFilter.domain, parsed.domain) && !_.isEmpty(parsed.domain)) {
                    c.currentFilter.domain = parsed.domain;
                }
                if (!_.isEqual(c.currentFilter.filters, parsed.filters) && !_.isEmpty(parsed.filters)) {
                    c.currentFilter.filters = parsed.filters;
                }
                if (!_.isEqual(c.currentFilter.limit, parsed.limit) && parsed.limit) {
                    c.currentFilter.limit = parsed.limit;
                }
                if (!_.isEqual(c.currentFilter.offset, parsed.offset) && parsed.offset) {
                    c.currentFilter.offset = parsed.offset;
                }
                if (!_.isEqual(c.currentFilter.sort, parsed.sort) && parsed.sort) {
                    c.currentFilter.sort = parsed.sort;
                }
            }
            function onError(error) {
                service.onError(error);
                msgService.loading(c.loading.items, 'ko');
                msgService.loading(c.loading.item, 'ko');
            }
            function getItem(id) {
                var deferred = $q.defer();
                var item;
                _.forEach(c.items, function (value) {
                    if (value){
                        if (value.id === id) {
                            item = value;
                        }
                    }
                });
                if (item) {
                    deferred.resolve(item);
                } else {
                    //do the request
                    msgService.loading(c.loading.item);
                    return dataService.get(c.contentType, id).then(
                        function (item) {
                            msgService.loading(c.loading.item, 'ok');
                            return item;
                        }, c.onError);
                }
                return deferred.promise;
            }
            function getCurrentItemId() {
                if (c.currentItem) {
                    return c.currentItem.id;
                }
            }
            function refreshCurrent() {
                var deferred = $q.defer();
                if (c.currentItem) {
                    msgService.loading(c.loading.item);
                    dataService.get(c.contentType, c.currentItem.id)
                    .then(function (item) {
                        msgService.loading(c.loading.item, 'ok');
                        c.setCurrent(item);
                        deferred.resolve(item);
                    }, function (error) {
                        c.onError(error);
                        deferred.reject(error);
                    });
                }
                return deferred.promise;
            }
            function setCurrent(item) {
                var deferred = $q.defer();
                if (item === undefined) {
                    delete c.currentItem;
                    deferred.resolve();
                } else {
                    if (typeof item === 'object') {
                        c.currentItem = item;
                        deferred.resolve(item);
                    } else {
                        if (typeof item === 'string') {
                            item = parseInt(item, 10);
                        }
                        msgService.loading(c.loading.item);
                        c.getItem(item).then(function (freshItem) {
                            msgService.loading(c.loading.item, 'ok');
                            c.currentItem = freshItem;
                            deferred.resolve(freshItem);
                        }, function (error) {
                            c.onError(error);
                            deferred.reject(error);
                        });
                    }
                }
                return deferred.promise;
            }
            function updateLocation() {
                var self = c;
                var prefix = 'c:' + self.id;
                if (!self.location) {
                    return;
                }
                var location = {};
                if (self.currentItem) {
                    location.current = self.currentItem.id;
                }
                if (self.currentFilter) {
                    location.domain = self.currentFilter.domain;
                    location.filters = self.currentFilter.filters; //extra filters
                    location.limit = self.currentFilter.limit;
                    location.offset = self.currentFilter.offset;
                    location.sort = self.currentFilter.sort;
                }
                if (!_.isEmpty(location)) {
                    $location.search(prefix, JSON.stringify(location));
                } else {
                    $location.search(prefix, null);
                }
            }

            function callbackRefresh(error, data) {
                if (!error) {
                    switch (data.action.id) {
                    case 'add':
                        //note: task create return id in data.result.result
                        data.model.id = data.result.data || data.result.result;
                        //refresh the collection
                        return c.getItems().then(function () {
                            return c.setCurrent(data.model.id);
                        }, service.onError);
                    case 'edit':
                        c.setCurrent(data.model.id);
                        return c.getItems();
                    case 'delete':
                        if (c.currentItem) {
                            if (data.model.id === c.currentItem.id) {
                                c.setCurrent();
                            }
                        }
                        return c.getItems();
                    case 'deactivate':
                        return c.getItems();
                    }
                }
            }
            function fasterCallback(data) {
                if (_.contains(['edit', 'cancel', 'add_to_cart', 'rm_from_cart'], data.action.id)) {
                    c.updateItem(data.model);
                }
                if (_.contains(['add', 'copy'], data.action.id)) {
                    if (data.result) {
                        var resultId = data.result.data || data.result.result;
                        var filter = {fields: c.currentFilter.fields};
                        return dataService.get(c.contentType, resultId, filter)
                            .then(function (source) {
                                c.items.unshift(source);
                            });
                        c.currentCount += 1;
                    }
                }
                if (_.contains(['delete', 'deactivate', 'activate'], data.action.id)) {
                    _.remove(c.items, function (item) {
                        return item.id === data.model.id;
                    });
                    c.currentCount -= 1;
                }
                if (_.contains(['router_delete'], data.action.id)) {
                    if (data.model.ids){
                        //each id in ids have to be delete from the collection
                        _.remove(c.items, function (item) {
                            return _.contains(data.model.ids, item.id);
                        });
                        c.currentCount -= data.model.ids.length;
                    }else{
                        _.remove(c.items, function (item) {
                            return item.id === data.model.id;
                        });
                        c.currentCount -= 1;
                    }
                }
                if (data.action.id === 'add_collection_to_cart') {
                    cart.addToCart(data.result);
                    // force to recompute actions (to display cart)
                    _.forEach(c.items, function (item) {
                        actionService.updateActions(item);
                    });
                }
            }
            function preModal(data) {
                //remove data.model for add action
                if (data.action.id === 'add') {
                    data.model = {};
                    _.defaults(data.model, settingsService.app.defaultValues[c.contentType]);
                }
                if(data.action.id === 'attachments') {
                    AttachmentService.attachmentPreModal(data, c);
                }
            }
            function defaultActionCallback(error, data) {
                if (error) {
                    c.onError(error);
                } else {
                    service.defaultCallbackMessage(error, data);
                    c.fasterCallback(data);
                }
            }
            function replaceItems(items) {
                c.items = items;
                c.currentCount = items.length;
            }
            function updateItem(item) {
                var target;
                //try to find the reference to the item in the collection
                _.forEach(c.items, function (_item) {
                    if (item.id === _item.id && item !== _item) {
                        target = _item;
                    }
                });
                var filter = {fields: c.currentFilter.fields};
                return dataService.get(c.contentType, item.id, filter)
                .then(function (source) {
                    dataService.updateObj(source, item);
                    if (target) {
                        dataService.updateObj(source, target);
                    }
                    return item;
                });
            }
            function removeItem(item) {
                _.remove(c.items, item);
                c.currentCount -= 1;
            }
        }

        function createOrUpdate(id, contentType, filter, options) {
            var c = service.createCollection(id, contentType, filter, options);
            if (c.contentType !== contentType) {
                c.contentType = contentType;
            }
            if (filter && !$location.search().doNotUpdateCollectionFilter) {
                c.currentFilter = filter;
            } else if ($location.search().doNotUpdateCollectionFilter === true) {
                //we delete the parameter after one use
                // this flag won't work if you have multiple collections for one location
                $location.search('doNotUpdateCollectionFilter', null);
            }
            if (options) {
                _.merge(c, options);
            }
            return service.getItems(id).then(function () {
                return service.collections[id];
            }, service.onError);
        }

        function addCollection(id, contentType, filter, options) {
            var c = service.createCollection(id, contentType, filter, options);
            if (c.items.length === 0) {
                return service.getItems(id).then(function () {
                    return service.collections[id];
                }, service.onError);
            } else {
                var deferred = $q.defer();
                deferred.resolve(c);
                return deferred.promise;
            }
        }

        function getItem(source, itemId) {
            msgService.loading(service.loading.items);
            var collection = service.getCollection(source);
            var contentType;
            if (collection) {
                contentType = collection.contentType;
            } else {
                contentType = source;
            }
            return dataService.get(contentType, itemId)
            .then(function (item) {
                msgService.loading(service.loading.items, 'ok');
                /*if (collection) {
                    collection.currentItem = item;
                }*/
                return item;
            }, service.onError);
        }

        function getCurrentItemId(id) {
            var collection = service.getCollection(id);
            if (collection) {
                return collection.getCurrentItemId();
            }
        }

        function setCurrentItem(cId, item, callback) {
            var itemId;
            if (typeof item === 'object') {
                itemId = item.id;
            } else {
                itemId = item;
            }
            var collection = service.getCollection(cId);
            if (item === undefined) {
                delete collection.currentItem;
                return;
            }
            return service.getItem(cId, itemId)
            .then(function (freshItem) {
                collection.currentItem = freshItem;
                $location.search('current:' + cId, itemId);
                if (callback) {
                    callback(null, freshItem);
                }
                return freshItem;
            }, function (error) {
                service.onError(error);
                if (callback) {
                    callback(error);
                }
            });
        }

        function _updateParams(collection) {
            var params = collection.currentFilter;
            if (params) {
                var offset = params.limit * (collection.currentPage - 1);
                if (params.offset !== offset) {
                    params.offset = offset;
                }
            }
        }

        function getItems(cId) {
            var c = service.getCollection(cId);
            if (c) {
                return c.getItems();
            }
        }

        function refreshCollections(ids) {
            var promises = [];
            var promise;
            _.forEach(ids, function (cId) {
                promise = service.getItems(cId);
                if (promise) {
                    promises.push(promise);
                }
            });
            return $q.all(promises);
        }

        function addCollectionToScope(cId, scope) {
            console.warn('DEPRECATION WARNING: collections.addCollectionToScope');
            console.warn('Please use methods on the collection itself');
            var collection = service.getCollection((cId));
            scope[cId] = collection;
            scope.CONTENT_TYPE = scope[cId].contentType;
            msgService.addOnErrorHandler(scope);

            scope.getItems = function () {
                return service.getItems(cId);
            };
            scope.getItem = function (id, type) {
                var contentType = type || scope.CONTENT_TYPE;
                return dataService.get(contentType, id);
/*                    .then(function (item) {
                    if (contentType === scope.CONTENT_TYPE) {
                        scope.currentItem = item;
                    }
                    return item;
                }, scope.onError);*/
            };
            scope.reloadItem = function (id) {
                return scope.getItem(id).then(function (item) {
                    for (var i = 0; i < collection.items.length; i++) {
                        if (collection.items[i].id === item.id) {
                            collection.items[i] = item;
                        }
                    }
                    return item;
                }, scope.onError);
            };

            scope.setCurrentItem = function (item, container, contentType) {
                if (container === undefined) {
                    container = 'currentItem';
                }
                if (contentType === undefined) {
                    contentType = scope.CONTENT_TYPE;
                }
                var itemId;
                if (typeof item === 'object') {
                    itemId = item.id;
                } else {
                    itemId = item;
                }
                return dataService.get(contentType, itemId)
                .then(function (freshItem) {
                    scope[container] = freshItem;
                    $location.search(container, itemId);
                    if (contentType === scope.CONTENT_TYPE && container === 'currentItem') {
                        if (scope.onCurrentItemSetted !== undefined) {
                            scope.onCurrentItemSetted(freshItem);
                        }
/*                            _.forEach(collection.items, function (value) {
                            if (value.id === itemId) {
                                collection.currentItem = value;
                            }
                        });*/
                        collection.currentItem = freshItem;
                    }
                    return freshItem;
                }, scope.onError);
            };
            if ($location.search().currentItem !== undefined) {
                scope.setCurrentItem(parseInt($location.search().currentItem, 10));
            }
            scope.defaultActionCallback = function (error, data) {
                if (error) {
                    scope.onError(error);
                } else {
                    switch (data.action.id) {
                    case 'add':
                        //note: task create return id in data.result.result
                        data.model.id = data.result.data || data.result.result;
                        msgService.addInfo('Item has been added successfully');
                        //refresh the collection
                        return service.getItems(cId).then(function () {
                            return scope.setCurrentItem(data.model);
                        }, scope.onError);
                    case 'edit':
                        msgService.addInfo('Item has been updated successfully');
                        return scope.setCurrentItem(data.model);
                    case 'delete':
                        msgService.addInfo('Item has been deleted successfully');
                        return service.getItems(cId);
                    }
                }
            };

        }
        /**
         * Build the string representation of a model field
         *
         * @param {object} value The value of the field
         * @param {object} An object describing the field
         *
         * @return {String} The field value as a string, depending on the type
         */
        function _fieldToString(value, description) {
        }

        /**
         * Export the collection as a csv file
         *
         * Writes a JS blob that can then be downloaded
         *
         * @param {Collection} the collection to be exported
         */
        function _saveAs(collection) {
            var data = '';
            var contentType = collection.contentType;
            // Retrieve the list of fields that should be exported
            var fields = settingsService.getContentType(contentType).saveAsFields;
            var serializedFieldsExtract = settingsService.getContentType(contentType).saveAsSerializedFieldExtract;
            var isView = settingsService.getContentType(contentType).isView;
            if (!fields) {
                fields = ['name'];
            }
            if (!(fields.includes('swif_id') || fields.includes('id')) && !(isView)) {
                data += 'id;';
            }
            dataService.getModelFields(contentType).then(function (modelFields) {
                _.forEach(fields, function (field) {
                    if (modelFields[field]) {
                        if (modelFields[field].string) {
                            data +=  '"' + modelFields[field].string + '";';
                        }else{
                            data +=  '"' + field + '";';
                        }
                    } else if (isView) {
                        // There is no column in view model then show column as they come from API
                        data +=  '"' + field + '";';
                    }
                });
                data += '\n';
                _.forEach(collection.items, function (item) {
                    if (!(fields.includes('swif_id') || fields.includes('id')) && !(isView)) {
                        if (item.swif_id) {
                            data +=  '"' + item.swif_id + '";';
                        } else {
                            data +=  '"' + item.id.toString() + '";';
                        }
                    }
                    _.forEach(fields, function (field) {
                        var value = item[field];
                        if (!modelFields[field]) {
                            return;
                        }
                        if (modelFields[field].type === 'many2one') {
                            if (_.size(value) === 2) {
                                data +=  '"' + value[1] + '";';
                            } else {
                                data +=  ';';
                            }
                        } else if (modelFields[field].type === 'integer') {
                            if (value !== undefined) {
                                data +=  '"' + value.toString() + '";';
                            } else {
                                data += ';';
                            }
                        } else if (modelFields[field].type === 'float') {
                            if (value !== undefined) {
                                data +=  '"' + value.toString() + '";';
                            } else {
                                data += ';';
                            }
                        } else if (modelFields[field].type === 'boolean') {
                            if (value) {
                                data +=  'Oui;';
                            } else {
                                data +=  'Non;';
                            }
                        } else if (modelFields[field].type === 'char') {
                            if (value) {
                                data +=  '"' + value + '";';
                            } else {
                                data += ';';
                            }
                        } else if (modelFields[field].type === 'text') {
                            if (value) {
                                //Replace double quotes by single quotes
                                value = value.replace(/"/g, "'");
                                data +=  '"' + value + '";';
                            } else {
                                data += ';';
                            }
                        } else if (modelFields[field].type === 'date') {
                            if (value) {
                                value = swifMomentUtility.formatDate(value, 'YYYY-MM-DD');
                            } else {
                                value = '';
                            }
                            data +=  '"' + value + '";';
                        } else if (modelFields[field].type === 'datetime') {
                            if (value) {
                                value = swifMomentUtility.formatDatetime(value, 'YYYY-MM-DD HH:mm:ss');
                            } else {
                                value = '';
                            }
                            data +=  '"' + value + '";';
                        } else if (modelFields[field].type === 'selection') {
                            if (value) {
                                var found = false;
                                _.forEach(modelFields[field].selection, function (v) {
                                    if (v[0] === value && !found) {
                                        found = true;
                                        value = v[1];
                                    }
                                });
                            } else {
                                value = '';
                            }
                            data +=  '"' + i18n.getString(value) + '";';
                        } else if (modelFields[field].type === 'many2many') {
                            if (value) {
                                value = value.join(' / ');
                            } else {
                                value = '';
                            }
                            data +=  '"' + value + '";';
                        } else if (modelFields[field].type === 'serialized') {
                            if (value && serializedFieldsExtract) {
                                let aggregatedValues = [];
                                value.map((val) => {
                                    let aggregatedFieldValues = [];
                                    serializedFieldsExtract.map((f)=> {
                                        if (f.field === field && f.indexes) {
                                            f.indexes.map((idx, index) => {
                                                if (val.length > idx && val[idx]) {
                                                    var resource;
                                                    if (index > 0) {
                                                        resource = "("+val[idx]+")";
                                                    } else {
                                                        resource = val[idx];
                                                    }
                                                    aggregatedFieldValues.push(resource);
                                                }
                                            })
                                        }
                                    });
                                    aggregatedValues.push(aggregatedFieldValues.join(' '));
                                });
                                value = aggregatedValues.join(', ')
                            } else {
                                value = '';
                            }
                          data +=  '"' + value + '";';
                        } else {
                            var msg = 'L\'export ne s\'est pas bien déroulé. ';
                            msg += 'Le type ' + modelFields[field].type;
                            msg += ' n\'est pas supporté';
                            msgService.addWarning(msg);
                        }
                    });
                    data += '\n';
                });
                var name = settingsService.getContentType(collection.contentType).title;
                var blob = new Blob([
                    new Uint8Array([0xEF, 0xBB, 0xBF]),
                    data
                ], {type: 'octet/stream;charset=utf-8'});
                saveAs(blob, 'opengst-' + name + '.csv');
            });
        }
    }


})();
